import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { Permission } from "../Model/Permission";

export async function getPermission(id) {
	let response = await getAPIResponse("/v1/permission/"+id);
	if (response === null) {
		return null;
	}
	let permission = Permission.createFromResponseData(response);
	return permission;
}